<!-- 组织机构员工树组件 -->
<template>
    <div class="org-user-tree-content">
         <el-input :class="'search-content'"
           placeholder="请输入关键字"
           prefix-icon="el-icon-search"
           v-model="filterText">
         </el-input>
        </el-input>
        <div class="tree-body">
            <el-tree class="filter-tree"
                :data="treeData"
                default-expand-all
                node-key="id"
                :filter-node-method="filterNode"
                @node-click="getNode"
                @check-change="buildNode"
                :show-checkbox="showCheckbox"
                ref="tree"
               >
               <span class="custom-tree-node" slot-scope="{ node, data }">
                   <span>
                       <i :class="data.icon"></i>{{ data.label }}
                   </span>
               </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import {getOrgUserTree} from '@/data-model';
    export default {
        data () {
            return {
                filterText: '',
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                treeSelectData: []
            };
        },
        props: {
            showCheckbox: {
                type: Boolean,
                default: false
            }
        },
        created () {
            this.initOrgTree();
        },
        methods: {
            filterNode (value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            getNode (data) {
                if (!this.showCheckbox) {
                    if (data.isLeaf === '0') { // 子节点,可以请求表单
                        this.$emit('loadUserForms', data);
                    }
                }
            },
            async initOrgTree () {
                let data = await getOrgUserTree();
                this.treeData = data;
            },
            getCheckUsers () {
                let nodes = this.$refs.tree.getCheckedNodes(true, false);
                return nodes;
            },
            buildNode (e) {
                let avg = this.getCheckUsers();
                this.$emit('loadUserForms', avg);
            }

        },
        watch: {
            filterText (val) {
                this.$refs.tree.filter(val);
            }
        }
    };
</script>

<style lang="less" scoped="scoped">
.org-user-tree-content{
    // height: 100%;
    .tree-body{
        overflow: auto;
        height: 52vh;
        border-left: 1px solid #d4d4d4;
        border-right: 1px solid #d4d4d4;
        border-bottom: 1px solid #d4d4d4;
    }
    .tree-body::-webkit-scrollbar{
        width: 1px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/OrgUserTree/OrgUserTree.vue